import { Text } from '@chakra-ui/react';
import { GradeTag } from '@lon/shared/components';
import { GradeLevelEnum } from '@lon/shared/gql/types';
import { getQuantileColor } from './duck';

const Quantile: React.FC<{
  score: string | undefined;
  gradeLevel: GradeLevelEnum;
}> = ({ score, gradeLevel }) => {
  const color = getQuantileColor({
    quantileScore: score!,
    gradeLevel,
  });

  return (
    <GradeTag
      color={color?.color}
      bgColor={color?.bgColor}
      w="85px"
      minH="44px"
      borderWidth="0"
      px={4}
      py="0.125rem"
    >
      <Text as="span" variant="s2" lineHeight="1.625rem">
        {`${score ? score.replace('-', 'EM') : '-'}`}
      </Text>
    </GradeTag>
  );
};

export default Quantile;
